import assignToThis from '../../helper/assignToThis';

export enum SurfaceTypeRef {
  simple = 'simple',
  medium = 'medium',
  sophisticated = 'sophisticated'
}

export enum InstallationTypeRef {
  tracker = 'tracker',
  fixedTilt = 'fixed_tilt',
  eastWest = 'east_west'
}

export class SurfaceDefinition {
  public surfaceTypeRef: SurfaceTypeRef | null = null;
  public completeAvailableArea: number | null  = null;
  public areaOfExclusion: number | null  = null;
  public lostArea: number | null  = null;
  public netUsableArea: number | null  = null;
  public moduleEfficiency: number | null  = null;
  public pvPlantPower: number | null  = null;
  public groundCoverageRatio: number | null  = null;
  public relativeColumnSpacing: number | null  = null;
  public installationTypeRef: InstallationTypeRef | null  = null;
  public yieldFromProspect: number | null  = null;
  public bifacialModule: boolean | null  = null;
  public albedoFromProspect: number | null  = null;
  public bifacialGain: number | null  = null;
  public systemUnavailability: number | null  = null;
  public gridUnavailability: number | null  = null;
  public otherLosses: number | null  = null;

  constructor(options: Partial<SurfaceDefinition> = {}) {
    assignToThis(this, options);
  }
}
